import React from 'react'
import { Link } from 'react-router-dom'

export default function CardProject({id, title, image, styleBtn, pathP})
{
    return(
        <div className="card-projects" id={id}>
            <div className="subtitle-section">{title}</div>
            <div className="img-card" id={image} alt="Dev projects"></div>
            <Link className="btn-card" id={styleBtn} to={{pathname: pathP}} onClick={() => { window.scrollTo(0, 0) }}>
             <p>Explore</p>
            </Link>
        </div>
    )
}